var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg004Card(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 20",
    height: 20,
    viewBox: "0 0 32 20",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Master_Card_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master_Card"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Red_x5F_Circle",
    cx: 10,
    cy: 10,
    fill: "#f93232",
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Yellow_x5F_Circle",
    d: "m22 0c-2.246 0-4.312.75-5.98 2h-.02v.014c-.396.298-.76.634-1.107.986h2.214c.308.313.592.648.855 1h-3.932c-.242.319-.464.652-.667 1h5.264c.188.324.365.654.518 1h-6.291c-.143.325-.269.658-.377 1h7.044c.104.326.186.661.258 1h-7.563c-.067.328-.123.66-.157 1h7.881c.039.328.06.661.06 1h-8c0 .339.027.67.06 1h7.882c-.038.339-.093.672-.162 1h-7.563c.069.341.158.673.261 1h7.044c-.108.342-.234.675-.377 1h-6.291c.151.344.321.678.509 1h5.264c-.202.348-.427.681-.669 1h-3.928c.266.352.553.687.862 1h2.215c-.348.353-.711.688-1.107.986 1.672 1.259 3.745 2.014 6 2.014 5.523 0 10-4.478 10-10s-4.477-10-10-10z",
    fill: "#fed049"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg004Card);
export default __webpack_public_path__ + "static/media/004-card.f4336579f8a2b88ddfc7e2de34decd33.svg";
export { ForwardRef as ReactComponent };